import '../styles/App.css';
import AboutSection from "./AboutSection";
import ProjectsSection from "./ProjectsSection";
import { memo, useEffect, useState } from "react";
import Loading from "./Loading";

import { loadScribbles, loadBackgroundColor } from "../scripts/app";

import SC2 from "../img/border_lines/2.webp";
import SC12 from "../img/border_lines/12.webp";
import SC13 from "../img/border_lines/13.webp";
import SC14 from "../img/border_lines/14.webp";
import SC15 from "../img/border_lines/15.webp";
import SC16 from "../img/border_lines/16.webp";
import SC17 from "../img/border_lines/17.webp";
import SC18 from "../img/border_lines/18.webp";
import SC23 from "../img/border_lines/23.webp";

import Socials from "./Socials";
import Name from './Name';
// import BlobCanvas from "./BlobCanvas";

function App() {
  const [curPage] = useState("start");

  useEffect(() => {
    loadScribbles([SC2, SC12, SC13, SC14, SC15, SC16, SC17, SC18, SC23]);
    loadBackgroundColor();
  }, []);

  if (curPage === "loading") {
    return <Loading />;
  }
  return (
    <div id="App">
      {/*<BlobCanvas />*/}
      <header>
        {/*<img src={VoronoiSpinner} alt={"A black and white polygon with an animated fractal voronoi pattern"}/>*/}
        <div><Name/></div>
      </header>
      <main>
        <AboutSection />
        <ProjectsSection />
        {/*<ClassesSection/>*/}
      </main>
      <Socials />
    </div>
  );
}

export default memo(App);
